// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Material
import { CircularProgress, Divider } from "@material-ui/core";
// Vendor
import { showNotify } from "vendor/application/disptach";
// Infrastructure
import { IntegrationsAPI } from "api/application/Integrations";
// Application
import { ElementsHandleAPI } from "vendor/application/handleMethods";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Button } from "@components/Input";
import { ElementsCustom } from "@components/Elements";
import DialogAction from "components/Dialog/DialogAction";
// SVG
import { channelsSvg } from "assets";
import { arrowRightSvg } from "@assets";

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aircall: false,
      open: false
    };
  }

  componentDidMount() {
    this.getIntegration();
  }

  getIntegration = async () => {
    const { access, actualProject } = this.props.data;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      const integration = await obj.get_integration_by_id();
      this.setState({ aircall: integration });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
      this.return();
    }
  };

  updateElement = (e, type, i) => {
    const { aircall } = this.state;
    const obj = new ElementsHandleAPI(aircall.info, e.target.value, type, i);
    obj.updateObj();
    this.setState({ aircall: aircall });
  };

  return = () => {
    const { history } = this.props;
    const { actualProject } = this.props.data;
    history.push(`/${actualProject.id}/integrations`);
  };

  putIntegration = async (e) => {
    e.preventDefault();
    const { access, actualProject } = this.props.data;
    const { aircall } = this.state;
    try {
      const obj = new IntegrationsAPI(
        actualProject.id,
        access,
        this.props,
        aircall
      );
      await obj.put_integration();
      this.props.dispatch(
        showNotify({ message: "integrations", type: "edit", severity: "success" })
      );
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  handleDelete = async () => {
    const { access, actualProject } = this.props.data;
    const { aircall } = this.state;
    try {
      const obj = new IntegrationsAPI(actualProject.id, access, this.props);
      await obj.delete_integration(aircall.id);
      this.props.dispatch(
        showNotify({ message: "integrations", type: "delete", severity: "success" })
      );
      this.return();
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  render() {
    const { aircall, open } = this.state;
    const { t } = this.props;
    const { isSending, actualLayout } = this.props.data;
    return (
      <React.Fragment>
        <div className={"cen_integrations"}>
          <div className={"header"}>
            <div className={"header_content"}>
              <div onClick={() => this.return()} className={"header_action"}>
                {arrowRightSvg()}
              </div>
              <div className={"header_image"}>{channelsSvg("aircall")}</div>
              <div className={"header_title"}>
                <span className={"title"}>
                  {t("integrations:channels.aircall.title")}
                </span>
                <span className={"description"}>
                  {t("integrations:categories.customer")}
                </span>
              </div>
            </div>
            <div className={"header_actions"}>
              {isSending ? (
                <Button
                  type={"primary"}
                  disabled
                  text={<CircularProgress size={21} />}
                />
              ) : (
                <Button
                  type={"primary"}
                  text={t("integrations:save.action_button")}
                  onClick={(e) => this.putIntegration(e)}
                />
              )}
            </div>
          </div>
          {aircall ? (
            <div className={"integration"}>
              {/* API ID */}
              <ElementsCustom
                t={t}
                type={"aircall"}
                input_type={"input"}
                element_type={"api_id"}
                element={aircall.info.api_id}
                updateElement={this.updateElement}
              />
              <Divider />
              {/* API TOKEN */}
              <ElementsCustom
                t={t}
                type={"aircall"}
                input_type={"input"}
                element_type={"api_token"}
                element={aircall.info.api_token}
                updateElement={this.updateElement}
              />
              <Divider />
              {/* WEBHOOK TOKEN */}
              <ElementsCustom
                t={t}
                type={"aircall"}
                input_type={"input"}
                element_type={"webhook_token"}
                element={aircall.info.webhook_token}
                updateElement={this.updateElement}
              />
            </div>
          ) : (
            <div className={"content"}>
              <div className="loading">
                <CircularProgress color="primary" size={50} />
              </div>
            </div>
          )}
        </div>
        {aircall && (
          <React.Fragment>
            {/* DELETE */}
            <div className={"cen_integrations delete"}>
              <div className={"integration"}>
                <div className={"integration_info"}>
                  <span className={"integration_info_title"}>
                    {t("integrations:channels.aircall.delete.title")}
                  </span>
                  <span className={"integration_info_description"}>
                    {t("integrations:channels.aircall.delete.description")}
                  </span>
                </div>
                <Button
                  type={"normal_delete"}
                  text={t("integrations:channels.aircall.delete.action_button")}
                  onClick={() => this.setState({ open: true })}
                />
              </div>
            </div>
            {/* DELETE MODAL */}
            <DialogAction
              t={t}
              actualLayout={actualLayout.layout}
              handleAction={this.handleDelete}
              handleClickOpen={() => this.setState({ open: false })}
              common
              open={open}
              item={{ name: "" }}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const edit = connect(mapStateToProps)(Edit);

export default withTranslation(["commons", "common"])(withRouter(edit));
